"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasCartesian2dTraceGraphicsComponent = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
/**
 * @public
 * Draws traces for cartesian 2d plots.
 */
class CanvasCartesian2dTraceGraphicsComponent {
    constructor() {
        this.type = core_1.EGraphicsComponentType.Entity;
        this.specification = {};
        this.transform = new core_1.NoTransformProvider();
    }
    getCacheId() {
        return "CanvasTraceGraphicsComponent";
    }
    initialize() {
        // no action needed
    }
    onBeforeUpdate() {
        // no action needed
    }
    update(entity, renderer, arg) {
        renderer.context.save();
        renderer.context.beginPath();
        const screenTransform = arg.drawTransforms.dataToInteractiveArea;
        const userTransform = arg.userTransform;
        renderer.context.strokeStyle = rc_js_util_1.RgbaColorPacker.getHexColorString(entity.graphicsSettings.traceColor);
        renderer.context.lineWidth = entity.graphicsSettings.traceLinePixelSize;
        const yMin = screenTransform.getVec3MultiplyY(arg.transformedDataRange.getYMin());
        const yMax = screenTransform.getVec3MultiplyY(arg.transformedDataRange.getYMax());
        for (let i = 0, iEnd = entity.data.getXTraceCount(); i < iEnd; ++i) {
            const x = screenTransform.getVec3MultiplyX(userTransform.forwardX(entity.data.getXTick(i)));
            renderer.context.moveTo(x, yMin);
            renderer.context.lineTo(x, yMax);
        }
        const xMin = screenTransform.getVec3MultiplyX(arg.transformedDataRange.getXMin());
        const xMax = screenTransform.getVec3MultiplyX(arg.transformedDataRange.getXMax());
        for (let i = 0, iEnd = entity.data.getYTraceCount(); i < iEnd; ++i) {
            const y = screenTransform.getVec3MultiplyY(userTransform.forwardY(entity.data.getYTick(i)));
            renderer.context.moveTo(xMin, y);
            renderer.context.lineTo(xMax, y);
        }
        renderer.context.stroke();
        renderer.context.restore();
    }
}
exports.CanvasCartesian2dTraceGraphicsComponent = CanvasCartesian2dTraceGraphicsComponent;
//# sourceMappingURL=canvas-cartesian-2d-trace-graphics-component.js.map